// extracted by mini-css-extract-plugin
module.exports = {"wrpr":"CompareCheckbox_wrpr__Vub_E","link":"CompareCheckbox_link__DgpTm"};